const o = {
  small: "bodySBold",
  medium: "bodyMBold",
  large: "bodyLBold"
}, l = {
  small: "12px",
  medium: "14px",
  large: "16px"
};
export {
  o as buttonFontSize,
  l as customIconSize
};
